
import MainLayout from './Main'
import wx from 'weixin-js-sdk'
// console.log("wx:%o", wx)
import auth from '../auth'
// console.log("auth:%o", auth)
import { mapState, mapMutations } from 'vuex'
import Search from 'vux/src/components/search/index.vue'
import Divider from 'vux/src/components/divider/index.vue'


export default {
  data () {
      return {
          value: '请输入小区名（查询一次仅需1钢蹦）',
          subtitleMsg:'你可能感兴趣的小区',
          lists: [],
          token: '',
          openid: '',
          reqNearbyUrl: null,
          reqHouseAreaUrl: null,
          reqType: null,
          community: ''
      }
  },
  computed: mapState({
    // 箭头函数可使代码更简练
    pageType: state => state.jw.type//state.count
  }),
  mounted() {
    console.debug(">>> mounted, query:%o", this.$route.query);
    if(this.$route.query.type != null){
      this.reqType = this.$route.query.type
    }
    else{
      this.reqType = '0'
    }

  },
  created() {
      console.debug(">>> home body state jw:%o",this.$store.state.jw)
      // console.log("created currentRoute:%o", this.$root.currentRoute);
      // console.log("route.query.type:%s",this.$route.query.type)
      if(this.$route.query.type === '1') {
        console.debug("bussiness area")
        this.reqNearbyUrl = "http://alphago.chemucao.cn/real/api/index.php/bizcycle/nearby"
        this.subtitleMsg = '你可能感兴趣的商圈'
        this.value = '请输入商圈名（查询一次仅需1钢蹦）'
        this.reqType = this.$route.query.type
      }
      else if(this.$route.query.type === '2') {
        console.debug("district area")
        this.reqNearbyUrl = "http://alphago.chemucao.cn/real/api/index.php/district/nearby"
        this.subtitleMsg = '你可能感兴趣的区县'
        this.value = '请输入区县名（查询一次仅需1钢蹦）'
        this.reqType = this.$route.query.type
      }
      else if(this.$route.query.type === '3'){
        console.debug("city area")
        this.reqNearbyUrl = "http://alphago.chemucao.cn/real/api/index.php/city/deal"
        this.subtitleMsg = '你可能感兴趣的城市'
        this.value = '请输入城市名（查询一次仅需1钢蹦）'
        this.reqType = this.$route.query.type
        this.updateType(this.reqType)
        console.debug(">>> home body after state type:%s", this.pageType)//this.$store.state.jw.type)
        this.community = '北京'
        auth.setCm(this.community)
        this.$router.push({ path: '/detail',query: { type: this.reqType }})
      }
      else{
        console.debug("nearby area")
        this.reqNearbyUrl = "http://alphago.chemucao.cn/real/api/index.php/community/nearby"
        this.reqType = 0
      }
      this.updateType(this.reqType)
      console.debug(">>> home body after state type:%s", this.pageType)//this.$store.state.jw.type)
      let lat = auth.getLat() //30.577927
      let longt = auth.getLongt() //114.03084
      this.openid = auth.getOpenid()
      this.token = auth.getToken()
      this.reqNearby(this.openid, this.token, lat, longt)
  },
  methods: {
    ...mapMutations([
      'updateType'
    ]),
    reqNearby: function(openid, token, latitude, longitude){
      // console.log("reqNearby: openid:%s, token:%s, latitude:%s, longitude:%s", openid, token, latitude, longitude)
      //let url = "http://alphago.chemucao.cn/real/api/index.php/community/nearby"
      let url = this.reqNearbyUrl
      let req_data = {openid:openid, token:token, latitude:latitude, longitude:longitude}
      // console.log("url:%s, req_data:%o", url, req_data)
      this.$http.post(url, req_data).then((data) => {
        data = data.body
        // console.log("successful data:%o", data)
        // // console.log("code:" + data.code + ",typeof:" + typeof(data.code))
        let res_data = data.data.nearby;
        // console.log("res_data:%o", res_data)
        if(data.code === 0){
          // // console.log("res_data:%o", res_data)
          var od = [];
          // // console.log("outputdata:%o", od);
          for(var p in res_data){
            // // console.log(p + ":" + res_data[p]["name"]);
            od.push(res_data[p]["name"]);
          }
          // this.$set('lists', {})
          this.lists = od;
          // console.log("list:%o", this.lists)
        }

      }, (response) => {
        let msg = "wxPayReg failed!!!" + response
        console.error(msg)
        alert(msg);
      });
    },
    submit: function(){
      this.openid = auth.getOpenid()
      this.token = auth.getToken()
      // console.log("openid:%s, token:%s, community:%s", this.openid, this.token, this.community)
      this.reqHouseArea(this.openid, this.token, this.community)
      auth.setCm(this.community);
    },
    updateCm: function(cm){
      // console.log("update cm:%s", cm)
      auth.setCm(cm);
    },
    reqHouseArea: function(openid, token, community){
      // console.log("openid:%s, token:%s, community:%s", openid, token,community)
      // let reqHouseAreaUrl = 'http://alphago.chemucao.cn/real/api/index.php/community/deal'
      let req_data = null
      // console.log("route.query.type:%s",this.$route.query.type)
      if(this.$route.query.type === '1') {
        console.debug("bussiness area")
        this.reqHouseAreaUrl = "http://alphago.chemucao.cn/real/api/index.php/bizcycle/deal"
        req_data = {openid:openid, token:token, bizcycle:community}
      }
      else if(this.$route.query.type === '2') {
        console.debug("district area")
        this.reqHouseAreaUrl = "http://alphago.chemucao.cn/real/api/index.php/district/deal"
        req_data = {openid:openid, token:token, district:community}
      }
      else if(this.$route.query.type === '3'){
        console.debug("city area")
        this.reqHouseAreaUrl = "http://alphago.chemucao.cn/real/api/index.php/city/deal"
        req_data = {openid:openid, token:token, city:community}
      }
      else{
        console.debug("nearby area")
        this.reqHouseAreaUrl = "http://alphago.chemucao.cn/real/api/index.php/community/deal"
        req_data = {openid:openid, token:token, community:community}
      }

      // var url = reqHouseAreaUrl;
      let url = this.reqHouseAreaUrl
      // console.log("reqHouseArea url:%s", url);
      this.$http.post(url, req_data).then((response) => {
        // console.log("PASS! response:%o", response);
        // console.log("data:%o", response.body.data)
        if(response.status === 200  && response.body.data.guess != null){
          var datalist = response.body.data.guess;
          // // console.log("type:%o, datalist:%o", typeof(datalist), datalist);
          var od = [];
          // // console.log("outputdata:%o", od);
          for(var p in datalist){
            // // console.log(p + ":" + datalist[p]["name"]);
            od.push(datalist[p]["name"]);
          }
          this.lists = od;
        }

      }, (response) => {
        // error callback
        console.error("FAIL!!! response:%o", response);
      });
    }
  },
  components: {
    Search,
    Divider,
    MainLayout
  }
}



// WEBPACK FOOTER //
// ./src/components/HomePay.vue